export default "__VITE_ASSET__46862009__"